$(document).ready(function () {
  // 获取变体选择器和显示区域
  var $variantSelector = $('[name="id"]');
  var $dimensionDisplay = $('#dimension-display');
  var $backInStockContainer = $('#back-in-stock-container');
  var $backInStockDisplay = $('#back-in-stock-display');

  if ($variantSelector.length) {
    // 初始化显示选中变体的数据
    updateVariantData($variantSelector.val());

    // 监听变体选择事件
    $variantSelector.on('change', function () {
      var selectedVariantId = $(this).val();
      updateVariantData(selectedVariantId);
    });
  }

  // 更新 Dimensions 和 Back in Stock Date 显示
  function updateVariantData(variantId) {
    var variantData = variantMetafields[variantId];

    // 更新 Dimensions
    if (variantData && variantData.dimensions) {
      $dimensionDisplay.text(variantData.dimensions);
    } else {
      $dimensionDisplay.text('N/A');
    }

    // 更新 Back in Stock Date
    if (variantData && variantData.inventory_quantity === 0 && variantData.back_in_stock_date) {
      var formattedDate = formatDate(variantData.back_in_stock_date);
      $backInStockDisplay.text('Back-in-stock date: ' + formattedDate);
      $backInStockContainer.show();
    } else {
      $backInStockContainer.hide();
    }
  }

  // 格式化日期为 DD-MM-YYYY
  function formatDate(dateString) {
    var dateParts = dateString.split('-'); // 按 '-' 分割日期字符串
    return dateParts[2] + '-' + dateParts[1] + '-' + dateParts[0]; // 重新排列为 DD-MM-YYYY
  }

  // Collection Scroll to Product Grid
  $(document).on('click', 'a[href="/collections/all"]', function( e ) {
    e.preventDefault();
    if (window.location.pathname.includes('/collections/')) {
      $('html, body').animate({
        scrollTop: $('.grid__item').offset().top - 150
      }, 500);
    } else {
      window.location.href = '/collections/all';
    }
  });
  
  // Collection Gallery Lightbox
  if( $('.cl-lp-gallery-ctn .gallery-items').length ) {
    $('.cl-lp-gallery-ctn .gallery-items').slickLightbox({
      itemSelector: 'a',
    });
    
    if( $('.cl-lp-gallery-ctn .gallery-items li').length > 8 ){
      $('.cl-lp-gallery-ctn .btn-load-more').show();
    }
  }

  // Load Gallery Items
  $('.cl-lp-gallery-ctn .btn-load-more').click(function(){
    $('.cl-lp-gallery-ctn .gallery-items li').show();
    $(this).hide();
  });


  
});
